import React, { useMemo } from 'react';
import { Select } from '@app/ui';

type MultiSelectFilterProps = {
    multiSelectOptions: { name: string; id: string }[];
    onChange: (selected) => void;
};

export const MultiSelectFilter = ({
    onChange,
    multiSelectOptions,
}: MultiSelectFilterProps) => {
    const handleChange = (value: string[]) => {
        const parsed = value.reduce((obj, v) => {
            obj[v] = true;
            return obj;
        }, {});

        onChange(parsed);
    };

    const options = useMemo(() => {
        const options = [];
        multiSelectOptions.forEach(
            o => o.id && options.push({ label: o.name || o.id, value: o.id }),
        );
        return options;
    }, [multiSelectOptions]);

    return (
        <Select
            mode="multiple"
            placeholder="Select"
            options={options}
            size="middle"
            onChange={handleChange}
            optionLabelProp="label"
            allowClear
            style={{ width: '100%' }}
        />
    );
};
